// <auto-generated>
// Code generated by EDHC (R) Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is
// regenerated.
// Hash: -1149614115
// </auto-generated>
export enum DocumentType {
  providerBio = 1,
  contract = 2,
  amendment = 3,
  rateSheet = 4,
  w = 5,
  map = 6,
  contact = 7,
  note = 8,
  certification = 9,
  surgeryplusCard = 10,
  blankReferralForm = 11,
  case = 12,
  medicalRecords = 13,
  recordsAuthorizationSigned = 14,
  referral = 15,
  postOp = 16,
  travelRelated = 17,
  memberQuestionnaire = 18,
  traditionalInsurance = 19,
  memberIdentification = 20,
  billing = 21,
  other = 22,
  recordsAuthorizationUnsigned = 23,
  medicalRecordsRequest = 24,
  postOpRequest = 25,
  paymentReceipt = 26,
  ub = 27,
  hcfa = 28,
  memberBill = 29,
  claimRejectionLetter = 31,
}
